import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {CreateFormInputCustomAttribute} from '../../../../../../../../src/components/common/createFormInputs/customAttibutes';
import {CustomFieldAttribute} from '../../../../../../../../src/models/api/customFieldAttributeModel';
import {CustomFieldModel} from '../../../../../../../../src/models/api/customFieldModel';
import {ResourceMap} from '../../../../../../../../src/store/appTypes';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {InlineLinkButton} from '../../../../../../../shared/ui/src/components/buttons/inlineLinkButton';

/*
 * Props.
 */

interface CreateContactCustomAttributesProps {
  customFields: ResourceMap<CustomFieldModel>;
  customAttributes: ReadonlyArray<CustomFieldAttribute>;
  isUserGlobalAdmin: boolean;
  isDisabled: boolean;
  onNavigateToCustomFieldsSettings: Handler;
  onUpdateCustomAttribute: (customFieldId: number, value: string) => void;
}

/*
 * Style.
 */

const StyledAddMoreFieldsContainerDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  padding-top: 20px;
  line-height: 24px;
`;

/*
 * Component.
 */

export const CreateContactCustomAttributes: FC<CreateContactCustomAttributesProps> = (props) => {
  const {
    customAttributes,
    customFields,
    isUserGlobalAdmin,
    isDisabled,
    onNavigateToCustomFieldsSettings,
    onUpdateCustomAttribute,
  } = props;

  return (
    <>
      {customAttributes.map((customAttribute) => (
        <CreateFormInputCustomAttribute
          key={customAttribute.id}
          customAttribute={customAttribute}
          customFields={customFields}
          onUpdate={onUpdateCustomAttribute}
          onDelete={(id) => onUpdateCustomAttribute(id, '')}
          isDisabled={isDisabled}
        />
      ))}
      {maybeRenderAddMoreFieldsMessage(isUserGlobalAdmin, onNavigateToCustomFieldsSettings)}
    </>
  );
};

/*
 * Helpers.
 */

function maybeRenderAddMoreFieldsMessage(
  isUserGlobalAdmin: boolean,
  onNavigateToCustomFieldsSettings: Handler,
) {
  if (!isUserGlobalAdmin) {
    return null;
  }
  return (
    <StyledAddMoreFieldsContainerDiv>
      <Trans id="create-contact-form-need-more-1">Need more contact fields?</Trans>{' '}
      <InlineLinkButton onClick={onNavigateToCustomFieldsSettings}>
        <Trans id="create-contact-form-need-more-link">Manage fields</Trans>
      </InlineLinkButton>{' '}
      <Trans id="create-contact-form-need-more-2">in Settings</Trans>
    </StyledAddMoreFieldsContainerDiv>
  );
}
